import { LitElement, html, svg } from 'lit';

export class IconPhone32 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><title>Smarttelefon</title><rect width="18.667" height="29.333" x="6.667" y="1.333" stroke="currentColor" stroke-width="1.5" rx="2.667"></rect><path fill="currentColor" d="M6.667 24.583a.75.75 0 0 0 0 1.5v-1.5Zm18.667 1.5a.75.75 0 0 0 0-1.5v1.5Zm0-1.5H6.667v1.5h18.667v-1.5Z"></path></svg>`; }
}
if (!customElements.get('f-icon-phone32', IconPhone32)) {
  customElements.define('f-icon-phone32', IconPhone32);
}